import { render, staticRenderFns } from "./PagosPage.vue?vue&type=template&id=4cc6528b&scoped=true"
import script from "./PagosPage.vue?vue&type=script&lang=js"
export * from "./PagosPage.vue?vue&type=script&lang=js"
import style0 from "./PagosPage.vue?vue&type=style&index=0&id=4cc6528b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6528b",
  null
  
)

export default component.exports